import { useEffect, useState } from "react";

// Several components own sockets; coalesce simultaneous reconnects into one fetch.
export default function useReconnectVersion() {
  const [version, setVersion] = useState(0);
  useEffect(() => {
    let timer;
    const refresh = () => {
      clearTimeout(timer);
      timer = setTimeout(() => setVersion(value => value + 1), 250);
    };
    window.addEventListener("app:reconnected", refresh);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("app:reconnected", refresh);
    };
  }, []);
  return version;
}
